import { render, staticRenderFns } from "./UpdateBasilForm.vue?vue&type=template&id=8f222d16&"
import script from "./UpdateBasilForm.vue?vue&type=script&lang=js&"
export * from "./UpdateBasilForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports